export class DisableSubmit {
  private originalText: string;
  private submittingText = '<div class="submit-loader"></div>';

  private isSubmitting = false;
  private submitButtonText: string;

  constructor(originalButtonText?: string, submittingText?: string) {
    this.originalText = originalButtonText !== undefined ? originalButtonText : 'Submit';
    this.submitButtonText = this.originalText;
    this.submittingText += submittingText !== undefined ? submittingText : 'Submitting...';
  }

  public setSubmitting(submit: boolean): void {
    this.isSubmitting = submit;
    this.submitButtonText = submit ? this.submittingText : this.originalText;
  }

  public getSubmitting(): boolean {
    return this.isSubmitting;
  }

  public getSubmitText(): string {
    return this.submitButtonText;
  }
}
